var map = {
	"./account/accountedit.vue": [
		9865,
		362,
		865
	],
	"./account/accountview.vue": [
		2709,
		362,
		865,
		709
	],
	"./account/changepassword.vue": [
		4791,
		362,
		791
	],
	"./courses/evaluation.vue": [
		954,
		954
	],
	"./courses/evaluationadd.vue": [
		2294,
		362,
		294
	],
	"./courses/list.vue": [
		82,
		82
	],
	"./courses/results.vue": [
		6861,
		861
	],
	"./courses/specialresit.vue": [
		9392,
		392
	],
	"./courses/view.vue": [
		1530,
		530
	],
	"./coursesenrolment/add.vue": [
		6957,
		362,
		957
	],
	"./coursesenrolment/edit.vue": [
		2063,
		362,
		63
	],
	"./coursesenrolment/list.vue": [
		2863,
		863
	],
	"./coursesenrolment/view.vue": [
		5008,
		8
	],
	"./custom/contact.vue": [
		9510,
		362,
		130
	],
	"./custom/faqs.vue": [
		4443,
		443
	],
	"./documentrequests/add.vue": [
		1967,
		362,
		967
	],
	"./documentrequests/cancel.vue": [
		3585,
		362,
		585
	],
	"./documentrequests/edit.vue": [
		8276,
		362,
		276
	],
	"./documentrequests/list.vue": [
		4047,
		47
	],
	"./documentrequests/view.vue": [
		6587,
		587
	],
	"./errors/forbidden.vue": [
		4497,
		497
	],
	"./errors/pagenotfound.vue": [
		6456,
		456
	],
	"./home/home.vue": [
		3050,
		199,
		468
	],
	"./home/matriculationoath.vue": [
		4916,
		362,
		916
	],
	"./index/forgotpassword.vue": [
		2587,
		343
	],
	"./index/index.vue": [
		8510,
		510
	],
	"./index/resetpassword.vue": [
		980,
		362,
		980
	],
	"./index/resetpassword_completed.vue": [
		4845,
		845
	],
	"./payments/list.vue": [
		1338,
		338
	],
	"./payments/view.vue": [
		1245,
		245
	],
	"./studentalerts/list.vue": [
		1567,
		567
	],
	"./studentalerts/todayalert.vue": [
		2199,
		199,
		463
	],
	"./studentalerts/view.vue": [
		9120,
		120
	],
	"./studentclearance/add.vue": [
		3180,
		362,
		180
	],
	"./studentclearance/list.vue": [
		5231,
		231
	],
	"./studentclearance/view.vue": [
		2771,
		771
	],
	"./studenttimetable/list.vue": [
		7241,
		241
	],
	"./timetables/examstimetable.vue": [
		7306,
		306
	],
	"./timetables/lecturetimetable.vue": [
		455,
		455
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2385;
module.exports = webpackAsyncContext;